"use strict";

exports.__esModule = true;
exports.getDefaultCustomVariant = void 0;
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
var _calculatePreferencesView = require("../../utils/calculatePreferencesView/calculatePreferencesView");
const getDefaultCustomVariant = ({
  serviceOptionsAndVariants,
  bookingsSettings,
  experiments,
  openedBy,
  service,
  queryParams
}) => {
  var _serviceOptionsAndVar;
  if (!serviceOptionsAndVariants) {
    return undefined;
  }
  const variants = (_serviceOptionsAndVar = serviceOptionsAndVariants.variants) == null ? void 0 : _serviceOptionsAndVar.values;
  if (!variants || variants.length === 0) {
    return undefined;
  }
  const isBookFlowSettingsEnabled = (0, _bookingsCalendarCatalogViewerMapper.isBookFlowSettingsEnabled)({
    experiments,
    bookingsSettings
  });
  const preferencesView = (0, _calculatePreferencesView.calculatePreferencesViewForAppointment)({
    service,
    bookingsSettings,
    serviceOptionsAndVariants,
    openedBy,
    queryParams
  });
  const variantDisplayOnPreferencesModal = isBookFlowSettingsEnabled && preferencesView[_calculatePreferencesView.PreferenceType.DYNAMIC_PRICE] === _calculatePreferencesView.DisplayTarget.PREFERENCES_MODAL;
  if (!variantDisplayOnPreferencesModal || !(0, _bookingsCalendarCatalogViewerMapper.isCustomVariant)(serviceOptionsAndVariants)) {
    return undefined;
  }
  const sorted = [...variants].sort((a, b) => {
    var _a$price, _b$price, _a$choices, _b$choices;
    const priceDiff = Number(((_a$price = a.price) == null ? void 0 : _a$price.value) ?? 0) - Number(((_b$price = b.price) == null ? void 0 : _b$price.value) ?? 0);
    if (priceDiff) {
      return priceDiff;
    }
    const nameA = ((_a$choices = a.choices) == null || (_a$choices = _a$choices[0]) == null ? void 0 : _a$choices.custom) || '';
    const nameB = ((_b$choices = b.choices) == null || (_b$choices = _b$choices[0]) == null ? void 0 : _b$choices.custom) || '';
    return nameA.localeCompare(nameB);
  });
  return sorted[0];
};
exports.getDefaultCustomVariant = getDefaultCustomVariant;
//# sourceMappingURL=getDefaultCustomVariant.js.map